import React from "react";
import { WEB_ROUTES } from "./constants.js";
import TripDetailScreen from "./Pages/TripManagement/TripDetailScreen.js";

const Account = React.lazy(() => import("./Pages/Account/index.js"));
const Dashboard = React.lazy(() => import("./Pages/Dashboard/index.js"));

const AddSchoolScreen = React.lazy(() =>
  import("./Pages/SchoolManagement/AddSchoolScreen.js")
);
const TripManagementScreen = React.lazy(() =>
  import("./Pages/TripManagement/TripManagementScreen.js")
);
const TransporterManagementScreen = React.lazy(() =>
  import("./Pages/TransporterManagement/TransporterManagementScreen.js")
);
const StudentManagementScreen = React.lazy(() =>
  import("./Pages/StudentManagement/StudentsManagementScreen.js")
);
const SchoolTransporterManagementScreen = React.lazy(() =>
  import(
    "./Pages/SchoolTransporterManagement/SchoolTransporterManagementScreen.js"
  )
);
const DriversManagementScreen = React.lazy(() =>
  import("./Pages/DriversManagement/DriversManagementScreen.js")
);
const SchoolManagementScreen = React.lazy(() =>
  import("./Pages/SchoolManagement/SchoolManagementScreen.js")
);
const PageManagementScreen = React.lazy(() =>
  import("./Pages/PageManagement/PageManagementScreen.js")
);
const SendNotificationScreen = React.lazy(() =>
  import("./Pages/SendNotification/SendNotificationScreen.js")
);
const Setting = React.lazy(() => import("./Pages/Setting/index.js"));
const UserDetails = React.lazy(() =>
  import("./Pages/UserManagement/UserDetails.js")
);
const UserManagementScreen = React.lazy(() =>
  import("./Pages/UserManagement/UserManagementScreen.js")
);
const ParentsManagementScreen = React.lazy(() =>
  import("./Pages/ParentsManagement/ParentsManagementScreen.js")
);

export const routeConfig = [
  {
    path: WEB_ROUTES.ACCOUNT,
    component: Account,
    isPublic: true,
    exact: true,
  },
  {
    path: WEB_ROUTES.DASHBOARD,
    component: Dashboard,
    isProtected: true,
    layoutProps: { isSearchBar: false },
    exact: true,
  },
  {
    path: WEB_ROUTES.USER_MANAGEMENT,
    component: UserManagementScreen,
    isProtected: true,
    layoutProps: { isSearchBar: false },
    exact: true,
  },
  {
    path: WEB_ROUTES.PARENTS_MANAGEMENT,
    component: ParentsManagementScreen,
    isProtected: true,
    layoutProps: { isSearchBar: false },
    exact: true,
  },
  {
    path: WEB_ROUTES.DRIVERS_MANAGEMENT,
    component: DriversManagementScreen,
    isProtected: true,
    layoutProps: { isSearchBar: false },
    exact: true,
  },
  {
    path: WEB_ROUTES.STUDENTS_MANAGEMENT,
    component: StudentManagementScreen,
    isProtected: true,
    layoutProps: { isSearchBar: false },
    exact: true,
  },
  {
    path: WEB_ROUTES.ADD_SCHOOL,
    component: AddSchoolScreen,
    isProtected: true,
    layoutProps: { isSearchBar: false },
    exact: true,
  },
  {
    path: WEB_ROUTES.SCHOOL_TRANSPORTER_MANAGEMENT,
    component: SchoolTransporterManagementScreen,
    isProtected: true,
    layoutProps: { isSearchBar: false },
    exact: true,
  },
  {
    path: WEB_ROUTES.TRIP_MANAGEMENT,
    component: TripManagementScreen,
    isProtected: true,
    layoutProps: { isSearchBar: false },
    exact: true,
  },
  {
    path: WEB_ROUTES.TRIP_DETAILS,
    component: TripDetailScreen,
    isProtected: true,
    layoutProps: { isSearchBar: false },
    exact: true,
  },

  {
    path: WEB_ROUTES.USER_DETAILS,
    component: UserDetails,
    isProtected: true,
    layoutProps: { isSearchBar: false },
    exact: true,
  },
  {
    path: WEB_ROUTES.TRANSPORTERS_MANAGEMENT,
    component: TransporterManagementScreen,
    isProtected: true,
    layoutProps: { isSearchBar: false },
    exact: true,
  },
  {
    path: WEB_ROUTES.SCHOOL_MANAGEMENT,
    component: SchoolManagementScreen,
    isProtected: true,
    layoutProps: { isSearchBar: false },
    exact: true,
  },
  {
    path: WEB_ROUTES.PAGE_MANAGEMENT,
    component: PageManagementScreen,
    isProtected: true,
    layoutProps: { isSearchBar: false },
    exact: true,
  },
  {
    path: WEB_ROUTES.SEND_NOTIFICATION,
    component: SendNotificationScreen,
    isProtected: true,
    layoutProps: { isSearchBar: false },
    exact: true,
  },
  {
    path: WEB_ROUTES.SETTING,
    component: Setting,
    isProtected: true,
    layoutProps: { isSearchBar: false },
    exact: true,
  },
];
